import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import ru from "./locales/ru.json";
import uk from "./locales/uk.json";
import es from "./locales/es.json";
import de from "./locales/de.json";
import fr from "./locales/fr.json";
import it from "./locales/it.json";
import pt from "./locales/pt.json";
import sv from "./locales/sv.json";
import da from "./locales/da.json";

export const SUPPORTED_LANGUAGES = [
  "en", "ru", "uk", "es", "de", "fr", "it", "pt", "sv", "da",
] as const;
export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

const resources = {
  en: { translation: en },
  ru: { translation: ru },
  uk: { translation: uk },
  es: { translation: es },
  de: { translation: de },
  fr: { translation: fr },
  it: { translation: it },
  pt: { translation: pt },
  sv: { translation: sv },
  da: { translation: da },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // Phase31-K: fall back to English instead of Russian when a key is
    // missing in a less-translated locale (fr/it/pt/sv/da are still
    // bootstrapped from en.json — bigger groups will be translated
    // language-by-language in subsequent commits).
    fallbackLng: "en",
    supportedLngs: [...SUPPORTED_LANGUAGES],
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "mavinty_language",
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
